<template style="background-color:black;">
  <b-container>
    <b-card
      v-if="cardType === 0"
      no-body
      border-variant="msstream"
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <b-img
              fluid
              :src="require(`@/assets/logo_Q_W.svg`)"
              class="logonavbar"
            ></b-img>
          </b-col>
        </b-row>

        <b-form @submit.prevent="onSubmit()">
          <b-row class="justify-content-center">
            <b-col class="col-md-6 col-sm-12">
              <b-form-group
                id="exampleInputGroup1"
                label="Username / email address:"
                label-for="exampleInput1"
              >
                <b-form-input
                  id="exampleInput1"
                  type="text"
                  v-model="form.name"
                  required
                  placeholder="Enter username or email address"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup2"
                label="Password:"
                label-for="exampleInput2"
              >
                <b-input-group>
                  <b-form-input
                    id="exampleInput2"
                    :type="passwordType"
                    v-model="form.password"
                    required
                    placeholder="Enter password"
                  >
                  </b-form-input>
                  <b-input-group-append>
                    <b-button
                      tabindex="-1"
                      v-if="passwordType === 'password'"
                      variant="db-sb1"
                      @click="passwordType = 'text'"
                      ><font-awesome-icon
                        :icon="['fas', 'eye']"
                      ></font-awesome-icon
                    ></b-button>
                    <b-button
                      tabindex="-1"
                      v-if="passwordType === 'text'"
                      variant="db-sb1"
                      @click="passwordType = 'password'"
                      ><font-awesome-icon
                        :icon="['fas', 'eye-slash']"
                      ></font-awesome-icon
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <p class="forgotPassword" @click="cardType = 1">
                <small>Forgot password ?</small>
              </p>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" variant="msstreamblue">Sign In</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="cardType === 1"
      no-body
      border-variant="msstream"
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <h2>Forgot password ?</h2>
          </b-col>
        </b-row>
        <b-form @submit.prevent="onClientPassword()">
          <b-row class="justify-content-center">
            <b-col class="col-md-6 col-sm-12">
              <b-form-group
                id="exampleInputGroup1"
                label="Username:"
                label-for="exampleInput1"
              >
                <b-form-input
                  id="exampleInput1"
                  type="text"
                  v-model="forgotUsername"
                  required
                  placeholder="Enter username"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" variant="msstreamblue">
                <font-awesome-icon icon="check" />
                Validate
              </b-button>
            </b-col>
            <b-col cols="auto">
              <b-button @click="cancelForgot" variant="quanteeclg">
                <font-awesome-icon style="color:red" icon="times" />
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="cardType === 2"
      no-body
      border-variant="msstream"
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <h2>Forgot password ?</h2>
          </b-col>
        </b-row>
        <b-form @submit.prevent="onValidateMail()">
          <b-row class="justify-content-center">
            <p v-if="!isUserMail">
              A new password will be sent to the following email address: <strong>{{ email }}</strong>
            </p>
            <p v-if="isUserMail">
              A new password will be sent to the following email address: <strong>{{ email }}</strong>
            </p>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" variant="msstreamblue">
                <font-awesome-icon icon="check" />
                Confirm
              </b-button>
            </b-col>
            <b-col cols="auto">
              <b-button @click="cancelForgot" variant="quanteeclg">
                <font-awesome-icon style="color:red" icon="times" />
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="cardType === 3"
      no-body
      border-variant="msstream"
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <h2>
              A valid email is now mandatory in order to use Quanteec services.
              Please enter a valid email.
            </h2>
          </b-col>
        </b-row>
        <b-form-input
          :state="correctMail"
          placeholder="email"
          v-model="newMail"
        >
        </b-form-input>
        <b-form @submit.prevent="putMyEmail">
          <b-row class="justify-content-center">
            <b-col class="col-md-6 col-sm-12"> </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" variant="msstreamblue">
                <font-awesome-icon icon="check" />
                Register email
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="cardType === 4"
      no-body
      border-variant="msstream"
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <b-row class="justify-content-center">
              <h4>
                Please modify the auto-generated password that was sent to you by email. 
                It must be changed for security reasons.
              </h4>
            </b-row>
            <b-row class="justify-content-center">
              <small>Passwords must contain at least: 7 characters, one lower
              letter, one upper letter, one digit and one special character</small>
            </b-row>
          </b-col>
        </b-row>
        <b-form @submit.prevent="putMyPassword">
        <b-input-group class="justify-content-center">
          <b-form-input
            style="max-width:400px"
            :state="correctPassword"
            placeholder="New password"
            v-model="newPassword"
            :type="passwordType"
          >
          </b-form-input>

          <b-input-group-append>
            <b-button
              tabindex="-1"
              v-if="passwordType === 'password'"
              variant="db-sb1"
              @click="passwordType = 'text'"
              ><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon
            ></b-button>
            <b-button
              tabindex="-1"
              v-if="passwordType === 'text'"
              variant="db-sb1"
              @click="passwordType = 'password'"
              ><font-awesome-icon
                :icon="['fas', 'eye-slash']"
              ></font-awesome-icon
            ></b-button>
          </b-input-group-append>

          <b-form-invalid-feedback>
            Passwords must contain at least: 7 characters, one lower
            letter, one upper letter, one digit and one special character
          </b-form-invalid-feedback>
        </b-input-group>

        <b-input-group class="justify-content-center">
          <b-form-input
            style="max-width:400px"
            :state="indenticalPasswords"
            placeholder="Confirm new password"
            v-model="confirmPassword"
            :type="confirmPasswordType"
          >
          </b-form-input>

          <b-input-group-append>
            <b-button
              tabindex="-1"
              v-if="confirmPasswordType === 'password'"
              variant="db-sb1"
              @click="confirmPasswordType = 'text'"
              ><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon
            ></b-button>
            <b-button
              tabindex="-1"
              v-if="confirmPasswordType === 'text'"
              variant="db-sb1"
              @click="confirmPasswordType = 'password'"
              ><font-awesome-icon
                :icon="['fas', 'eye-slash']"
              ></font-awesome-icon
            ></b-button>
          </b-input-group-append>

          <b-form-invalid-feedback>
            Passwords must be identical
          </b-form-invalid-feedback>
        </b-input-group>

        
          <b-row class="justify-content-center m-3">
            <b-col class="col-md-6 col-sm-12"> </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" variant="msstreamblue" >
                <font-awesome-icon icon="check" />
                Update password
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-modal ref="myModalRef" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="exclamation-triangle" />
          Login error       
        </h4>
      </div>
      <div style="text-align:center" v-for="(error, index) in errors" v-bind:key="index">
        <p style="line-height:normal">{{ error }}.
          <br /><br /> Use the <strong>'Forgot password ?'</strong> link <br />or contact <strong>QUANTEEC</strong> at: <strong>support@quanteec.com</strong>.
        </p>
      </div>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('myModalRef')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Close
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="userNotFound" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="exclamation-triangle" />
          Error username
        </h4>
      </div>
      <p style="line-height:normal; text-align:center">This username is unknown. <br /><br />Please verify the username <br />or contact <strong>QUANTEEC</strong> at: <strong>support@quanteec.com</strong></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('userNotFound')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Close
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="mailError" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="envelope-open" />
          Error email
        </h4>
      </div>
      <p style="line-height:normal; text-align:center">{{ errorMsg }}</strong></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('mailError')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Close
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorMailUsed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="envelope-open" />
          Error email
        </h4>
      </div>
      <p style="line-height:normal; text-align:center">This email address is already used by another account.</strong></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorMailUsed')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Close
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorMail" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'envelope-open']" />
          Error email
        </h4>
      </div>
      <p style="line-height:normal; text-align:center">Error in email change.</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorMail')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Close
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="validationMail" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'envelope-open']" />
          Verification email sent
        </h4>
      </div>
      <p style="line-height:normal; text-align:center">A verification email has been sent. Please validate the email in order to use QUANTEEC services.</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('validationMail')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Close
        </b-btn>
      </b-row>
    </b-modal>


        <b-modal ref="mailPassword" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>New password sent</h3>
      </div>
      <p>A new password has been sent to the email link to your account.</p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="mswarning"
          block
          @click="hideModal('mailPassword')"
          >Close</b-btn
        >
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import UserService from "@/services/user.service";
let userService = new UserService();
var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function (e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = ((n & 3) << 4) | (r >> 4);
      u = ((r & 15) << 2) | (i >> 6);
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.charAt(u) +
        this._keyStr.charAt(a);
    }
    return t;
  },
  decode: function (e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = (s << 2) | (o >> 4);
      r = ((o & 15) << 4) | (u >> 2);
      i = ((u & 3) << 6) | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function (e) {
    e = e.replace(/\r\n/g, "\n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function (e) {
    var t = "";
    var n = 0;
    var c1;
    var c2;
    var r = (c1 = c2 = 0);
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  },
};
export default {
  name: "Login",
  data: function () {
    return {
      form: {
        name: "",
        password: "",
      },
      errorMsg: "",
      forgotUsername: "",
      cardType: 0,
      userClient: "client",
      email: "te**@quanteec.com",
      passwordType: "password",
      errors: [],
      isUserMail: "false",
      newMail: "",
      correctMail: undefined,
      correctPassword: undefined,
      indenticalPasswords: undefined,
      newPassword: "",
      confirmPassword: "",
      confirmPasswordType: "password",
    };
  },
  mounted() {
    if (this.$route.params["username"]) {
      this.form.name = Base64.decode(this.$route.params["username"]);
    }
    if (this.$route.name === "mail") this.cardType = 3;
    if (this.$route.name === "changePassword") this.cardType = 4;
  },
  methods: {
    onSubmit: function () {
      if (this.validateForm()) {
        this.$auth
          .setUsernamePassword(this.form.name, this.form.password)
          .then(() => {
            EventBus.$emit("AuthChanged");
            this.$router.push("/");
          })
          .catch(() => {
            this.errors.push("Wrong username or password");
            this.showModal("myModalRef");
          });
      }
    },
    onReset: function () {
      this.form = {
        name: "",
        password: "",
      };
    },
    onClientPassword: function () {
      userService
        .getUserForgot(this.forgotUsername)
        .then((client) => {
          this.email = client.email;
          console.log(client.isUserMail);
          this.isUserMail = client.isUserMail;
          this.cardType = 2;
        })
        .catch((err) => {
          this.showModal("userNotFound");
        });
    },
    cancelForgot: function () {
      this.cardType = 0;
      this.email = "";
      this.forgotUsername = "";
      this.onReset();
    },
    onValidateMail: function() {
      userService.postUserForgot(this.forgotUsername).then(() => {
        this.showModal("mailPassword")
        this.cardType = 0;
      }).catch(err => {
        console.log("Error : ", err)
        if (err.response && err.response.data) {
          this.errorMsg = err.response.data
        } else {
          this.errorMsg = "Unknown error. Please retry later or contact QUANTEEC at: support@quanteec.com"
        }
        this.showModal('mailError')
      })
    },
    validateForm: function () {
      var isValidated = true;
      this.errors = [];
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.form.name)) {
        isValidated = true;
      }
      return isValidated;
    },
    showModal(myModalRef) {
      this.$refs[myModalRef].show();
    },
    hideModal(myModalRef) {
      this.$refs[myModalRef].hide();
    },
    validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    putMyEmail() {

      if (this.validateEmail(this.newMail)) {
        this.correctMail = true;
        userService
          .putUser(
            this.$auth.getMyUser().username,
            {
              newEmail: this.newMail,
              emailVerified: false,
              oldPassword: atob(this.$auth.token()).split(":")[1],
              keyMail: [...Array(64)]
                .map((i) => (~~(Math.random() * 36)).toString(36))
                .join(""),
                timestamp:new Date(),
            },
            this.$auth.token()
          )
          .then((user) => {
            this.showModal("validationMail")
            this.$auth
              .validateWithServer()
              .then(() => {
                EventBus.$emit("AuthChanged");
              })
              .catch((err) => {
                EventBus.$emit("AuthChanged");
                if (window.location.href.indexOf("/#/auth") === -1) {
                  this.$router.push("/auth");
                }
              });
          })
          .catch((err) => {
            this.correctMail = false;
            if (err.response.status === 409) this.showModal("errorMailUsed");
            else {
              this.showModal("errorMail");
            }
          });
      } else {
        this.correctMail = false;
      }
    },
    putMyPassword() {
      if (this.newPassword != this.confirmPassword) {
        this.indenticalPasswords = false;
        return;
      } else {
        this.indenticalPasswords = "";
      }

      let count = 0;
      if (this.newPassword.length >= 7) {
        if (this.newPassword.match(/.*[0-9].*/)) count++;

        if (this.newPassword.match(/.*[a-z].*/)) count++;

        if (this.newPassword.match(/.*[A-Z].*/)) count++;

        if (this.newPassword.match(/.*[!@#\$%\^\&*\)\(+=._-].*/)) count++;
      }

      if (count === 4) {
        this.correctPassword = true;
        this.indenticalPasswords = true;
        userService
          .putUser(
            this.$auth.getMyUser().username,
            { password: this.newPassword, oldPassword:atob(this.$auth.token()).split(":")[1] },
            this.$auth.token()
          )
          .then((user) => {
            this.$auth.setUsernamePassword(
              this.$auth.getMyUser().username,
              this.newPassword
            );

            this.$auth
              .validateWithServer()
              .then(() => {
                EventBus.$emit("AuthChanged");
                this.$router.push("/");
              })
              .catch((err) => {
                EventBus.$emit("AuthChanged");
                if (window.location.href.indexOf("/#/auth") === -1) {
                  this.$router.push("/auth");
                }
              });
          })
          .catch((err) => {
            this.showModal("errorPassword");
            console.log(err);
          });
      } else {
        this.correctPassword = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
body {
  background: black;
}

.forgotPassword {
  color: grey;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
